import "./LanguagePicker.scss";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "../../i18n";
import { setLanguage } from "../../i18n/language";

// Switches the UI language right away (and saves it on the account)
function LanguagePicker() {
  const { i18n } = useTranslation();

  return (
    <div className="language-picker" role="radiogroup">
      {LANGUAGES.map((language) => (
        <button
          key={language.code}
          type="button"
          role="radio"
          aria-checked={i18n.resolvedLanguage === language.code}
          className={`language-picker__option ${i18n.resolvedLanguage === language.code ? "is-active" : ""}`}
          onClick={() => setLanguage(language.code)}
        >
          {language.name}
        </button>
      ))}
    </div>
  );
}

export default LanguagePicker;
